import { IconButton } from "@/src/components/buttons";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId } from "@/src/utils/utils";
import moment from "moment";
import { useState } from "react";
import { IoClose } from "react-icons/io5";
import { PiMagicWand } from "react-icons/pi";
import AiDiscussion from "./aiDiscussion";
import { RiRobot2Line } from "react-icons/ri";

export function AiButton({
  onChange,
}: {
  onChange: (isOpen: boolean) => void;
}) {
  const [discussionId, setDiscussionId] = useState<string | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  function close() {
    setIsOpen(false);
    onChange(false);
    setDiscussionId(null);
    window.document.body.classList.remove("small");
  }
  async function open() {
    let discussion = await apiFetch("aiDiscussions", "addOne", {
      item: {
        name: `Discussion ${moment().format("DD/MM/YYYY HH:mm")}`,
        description: "",
        creator: getUserId(),
      },
    });
    setDiscussionId(getItemId(discussion));
    setIsOpen(true);
    onChange(true);
    window.document.body.classList.add("small");
  }

  return null;

  return (
    <div
      className=" bs2"
      style={
        isOpen
          ? {
              position: "fixed",
              bottom: 0,
              right: 0,
              zIndex: 9999999999,
              width: "500px",
              borderLeft: "4px solid RGB(0,0,0,0.2)",
              background: "white",
              height: "100vh",
              overflowY: "auto",
            }
          : { position: "fixed", bottom: 120, right: 20, zIndex: 9999999999 }
      }
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {!isOpen && (
        <div
          style={{
            position: "fixed",
            bottom: 120,
            right: 20,
            zIndex: 9999999999,
          }}
        >
          <IconButton
            width={70}
            isMain={true}
            height={70}
            
            onClick={async (e) => {
              e.stopPropagation();
              if (isOpen) close();
              else await open();
            }}
          >
            {isOpen ? <IoClose size={25} /> : <RiRobot2Line size={30} />}
          </IconButton>
        </div>
      )}

      {isOpen && discussionId && (
        <AiDiscussion
          discussionId={discussionId!}
          onClose={close}
        ></AiDiscussion>
      )}
    </div>
  );
}

export default AiButton;
